/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './loader-container.html';

export default defineComponent({
  name: 'LoaderContainer',
  template,
  emits: {},
  props: {
    animate: { type: Boolean, required: false, default: false },
    colorInverted: { type: Boolean, required: false, default: false }
  }
});
